import parsePhoneNumberFromString,  { isSupportedCountry } from "libphonenumber-js";
import React, { Component, CSSProperties } from "react";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


interface Props {
  initialValue?: string;
  value?: string;
  style?: CSSProperties;
  onChange?: (value: string, data?: {} | CountryData, event?: React.ChangeEvent<HTMLInputElement>, formattedValue?: string) => void;
  disabled: boolean | false;
}


class PhoneNumber extends Component<Props, Record<string, unknown>> {
  handleChange = (value: string, data?: {} | CountryData, event?: React.ChangeEvent<HTMLInputElement>, formattedValue?: string): void => {
    const parsedValue = value.split(" ").join("");
    this.props.onChange && this.props.onChange(parsedValue, data, event, formattedValue);
  };

  componentDidUpdate(prevProps: Props): void {
    const initialValue = this.props.initialValue;
    if (initialValue && initialValue !== prevProps.initialValue) {
      this.handleChange(initialValue);
    }
  }

  componentDidMount(): void {
    this.props.initialValue && this.handleChange(this.props.initialValue);
  }

  render(): JSX.Element {
    const { style, value, initialValue, disabled } = this.props;
    return (
      <div className="phone-input-container" style={style}>
        <PhoneInput
          inputStyle={style}
          value={value || initialValue}
          country={"gh"}
          onChange={this.handleChange}
          enableAreaCodes={false}
          disabled={disabled}
          isValid={(value,data) => {
            if (!value) return true;
            const iso2 =
              data && typeof data === "object" && "iso2" in data
                ? (data as { iso2?: string }).iso2
                : undefined;
            if (!iso2) return true;
            const upperIso2 = iso2.toUpperCase();
            const parsedPhone = isSupportedCountry(upperIso2)
              ? parsePhoneNumberFromString("+" + value, upperIso2)
              : parsePhoneNumberFromString("+" + value);
            if (parsedPhone) {
              return parsedPhone.isValid();
            }
            return false;
          }}
        />
      </div>
    );
  }
}
export default PhoneNumber;
